import React, { useState, useEffect } from "react";
import Checkbox from "../common/input/checkbox";

const FeedbackContentNew = ({ activeBtn, CategoriesData = false, readOnly = false, RatingData=false, submitFeedback }) => {
    // console.info(CategoriesData)
    const [activeTab, setActiveTab] = useState(1);
    const [feedbackRating, setfeedbackRating] = useState(0);
    const [active, setActive] = useState(false);
    const [lostItemTxt, setLostItemTxt] = useState("");
    const [isSubjectDisabled, setSubjectIsDisabled] = useState(false);
    const labels = [
        { name: "Worst", color: "#E72A01" },
        { name: "Poor", color: "#E72A01" },
        { name: "Average", color: "#E72A01" },
        { name: "Good", color: "#4FBA99" },
        { name: "Excellent", color: "#4FBA99" },
    ];
    const [subject, setSubject] = useState("");
    const [showFeedback, setShowFeedback] = useState(false);
    const [ratings, setRatings] = useState({});
    const [selectSubject, setSelectSubject] = useState([]);
    const [feedback, setFeedback] = useState("");
    const [file, setFile] = useState(null);
    const [tktNo, setTktNo] = useState("");
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);
    const [fileUrl, setFileUrl] = useState(false);
    const [lostItem,setLostItem] = useState(false);
    const LostItem = "Lost Item";

    useEffect(() => { }, [subject]);
    const handleSubjectChange = (el) => {
        setSubject(el);
    };

    useEffect(() => {
        if (CategoriesData) {
            const categories = Object.keys(CategoriesData);
            //setSelectSubject([...categories, LostItem]);
            setSelectSubject([...categories]);
            setSubject(categories[0]);
        }
    }, [CategoriesData]);

    useEffect(()=>{
         console.info(RatingData)
        if(RatingData){
            try {
                if( RatingData.Table1 && RatingData.Table1[0] && RatingData.Table1[0].FeedbackTime !="" && RatingData.Table2 && RatingData.Table2[0]){
                    let result = {};

                    RatingData.Table2.forEach(item => {
                    result[item.SubCategoryID] = item.rating;
                    });
                    setRatings(result)
                    setShowFeedback(true);
                    setLostItem(RatingData.Table1[0].LostItemRemarks ? true : false);
                    setLostItemTxt(RatingData.Table1[0].LostItemRemarks || "")
                    setFileUrl(RatingData.Table1[0].SupportingDoc || "")
                    setfeedbackRating(RatingData.Table1[0].OverAllRating);
                    setFeedback(RatingData.Table1[0].CustomerRemark || "");
                }
                
            } catch (error) {
                
            }
        }
    },[RatingData])

    useEffect(() => {
        const rt = Object.values(ratings);
        const selRating = rt.some((value) => value > 0);
        if (selRating) {
            setShowFeedback(true);
        } else {
            setShowFeedback(false);
        }
    }, [ratings]);

    const handleRatingChange = (category, value) => {
        setRatings((prevRatings) => ({
            ...prevRatings,
            [category]: value,
            // [category]: prevRatings[category] === value ? 0 : value,
        }));
        // setShowFeedback(true)
    };

    function getFilename(url) {
        return url.substring(url.lastIndexOf('/') + 1);
    }

    const handleStarClick = (val) => {
        setfeedbackRating(val);
        setActive(true);
        setSubjectIsDisabled(false);
    };

    const renderStars = (category) => {
        return [1, 2, 3, 4, 5].map((star) => (
            <span
                key={star}
                className={`star ${star <= ratings[category] ? "selected" : ""}`}
                onClick={() => !readOnly && handleRatingChange(category, star)}
            >
                {star <= ratings[category] ? "★" : "☆"}
            </span>
        ));
    };

    const RatingContent = (page = false) => {
        if (page && CategoriesData[page]) {
            return (
                <div className="ratings">
                    {CategoriesData[page].map((item) => (
                        <div className="ratings-star-icon" key={item.SubCategoryID}>
                            <div className="star-icon-heading">
                                <span>{item.SubCategory}</span>
                                <div>{renderStars(item.SubCategoryID)}</div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }
        return <></>;
    };

    const LostItemUI = () => (
        <textarea
            value={lostItemTxt}
            onChange={(e) => {
                !readOnly && setLostItemTxt(e.target.value);
            }}
            className="lostItemTa"
            placeholder="Describe the Lost Item with details such as color, brand, make, etc."
            maxLength="500"
            rows="4"
            disabled={readOnly}
        />
    );

    const renderSubjectUI = (page) => {
        // console.info
        switch (page) {
            case LostItem:
                return LostItemUI();

            default:
                return RatingContent(page);
        }
    };

    const subjectContent = () => {
        return (
            <>
                <div className={`feedback-form ${isSubjectDisabled ? "disabled" : ""}`}>
                    <h3>ii. Select Subject</h3>
                    <div className="subject-selection">
                        <div className="selection-radio-button">
                            {selectSubject.map((el, index) => (
                                <label
                                    key={`selSbjctMp${index}`}
                                    className={
                                        el === subject ? "enable-input-label" : "input-label"
                                    }
                                >
                                    <input
                                        type="radio"
                                        value={subject}
                                        checked={el === subject}
                                        onChange={() => handleSubjectChange(el)}
                                        style={{ width: "16px", height: "16px" }}
                                    />
                                    <span>{el}</span>
                                </label>
                            ))}
                        </div>
                        {renderSubjectUI(subject)}
                    </div>
                </div>
                {/* <div className={`feedback-form-buttons ${!showFeedback ? 'disabled' : ''}`}>
                <button>SKIP & SUBMIT FEEDBACK</button>
                <button>PROCEED TO PROVIDE COMMENT</button>
            </div> */}
                {!readOnly && <div
                    className={
                        (showFeedback || lostItemTxt.length>0)  && feedbackRating > 0
                            ? "feedback-form-buttons"
                            : "feedback-form-buttons-disabled"
                    }
                >
                    <button onClick={handleSubmit}>SKIP & SUBMIT FEEDBACK</button>
                    <button onClick={() => setActiveTab(2)}>PROCEED TO PROVIDE COMMENT</button>
                </div>}
            </>
        );
    };

    const feedbackUI = () => {
        return (
            <>
                <div className="star-rating-heading">
                    <h4>i. Overall Feedback</h4>
                    <div className="star-rating-container">
                        {labels.map((star, index) => {
                            const ratingValue = index + 1;
                            const isSelected = ratingValue <= feedbackRating;
                            return (
                                <div className="star-rating" key={`selStrRtgMp${index}`}>
                                    <label key={index}>
                                        <input
                                            type="radio"
                                            name="rating"
                                            value={ratingValue}
                                            onClick={() => !readOnly && handleStarClick(index + 1)}
                                        />
                                        <span
                                            className={isSelected ? "active-star" : "star"}
                                            role="img"
                                            aria-label={`${ratingValue} star`}
                                        >
                                            {isSelected ? "★" : "☆"}
                                        </span>
                                    </label>
                                    <span
                                        style={{
                                            color:
                                                ratingValue === feedbackRating ? star.color : "#444",
                                        }}
                                    >
                                        {star.name}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
                {subjectContent()}
            </>
        );
    };

    const handleFeedbackChange = (event) => {
        setFeedback(event.target.value);
    };

    const handleFileChange = (event) => {

        const selectedFile = event?.target?.files[0];
        if (selectedFile) {
            const maxSize = 1 * 1024 * 1024; // 1MB in bytes
            const allowedTypes = ['application/zip', 'application/pdf', 'image/jpeg'];

            if (!allowedTypes.includes(selectedFile.type)) {
                alert('Only .zip, .pdf, and .jpg files are allowed.');
                event.target.value = ''; // Clear the selectedFile input
                return;
            }

            if (selectedFile.size > maxSize) {
                alert('File size must be less than 1MB.');
                event.target.value = ''; // Clear the file input
                return;
            }
            setFile(selectedFile);
        }
    };

    const handleSubmit =async (event) => {
        event.preventDefault();
        // console.log("Feedback:", feedback);
        // console.log("File:", file);
        // console.log(ratings)
        // console.log(showFeedback)
        // console.log(feedbackRating)

        let payload = {};
        payload["overAllRating"] = feedbackRating;
        payload["comments"] = feedback || "";
        payload["lostItemComments"] = lostItemTxt || "";
        const subCategories = Object.keys(ratings).join('~');
        const ratingsT = Object.values(ratings).join('~');
        payload["subCategories"] = subCategories;
        payload["ratings"] = ratingsT;
        payload["file"] = file ? file : false;

        // console.info(payload)

        const resp = await submitFeedback(payload)
        console.info(resp.success)
        if(resp?.success){
            setTktNo(resp.tktNo)
            setShowModal(true)
        }

        // Handle form submission logic here
    };

    const handleRemoveFile = () => {
        !readOnly && setFile(null);
    };

    const comment = () => {
        return (
            <>
                <div className="attachment-container">
                    <h4 className="attachment-heading">i. Overall Feedback</h4>
                    <div className="attachment-textarea">
                        <p>
                            We are sorry about your experience. Could you please describe what
                            you didn t like ?
                        </p>
                        <div>
                            <textarea
                                id="feedback"
                                value={feedback}
                                onChange={handleFeedbackChange}
                                placeholder="Overall the bus service could have been better in terms of cleanliness, and dropping & boarding points. Overall the bus service could have been better in terms of cleanliness."
                                rows="4"
                                maxLength="500"
                                disabled={readOnly}
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div className="file-upload">
                    <h4 className="file-upload-heading">ii. Attachment</h4>
                    <div className="file-upload-attachment">
                        <div className="file-upload-attachment-label">
                            <label className="upload-label" htmlFor="file-input">
                                <span className="upload-button">
                                    <svg
                                        style={{ paddingTop: "3px" }}
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7 12V3.85L4.4 6.45L3 5L8 0L13 5L11.6 6.45L9 3.85V12H7ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V11H2V14H14V11H16V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2Z"
                                            fill="#FF7100"
                                        />
                                    </svg>

                                    <span> Upload Supporting File</span>
                                </span>
                                <input
                                    id="file-input"
                                    type="file"
                                    accept=".zip, .pdf, .jpg"
                                    onChange={handleFileChange}
                                    disabled={readOnly}
                                    />
                            </label>
                            <div className="file-preview-container">
                                {( (!readOnly && file) || (readOnly && fileUrl && fileUrl?.length > 2) ) && (
                                    <div className="file-preview">
                                        {!readOnly && file && <span>{file.name}</span> }
                                        {readOnly && fileUrl && fileUrl?.length > 2 && <span>{getFilename(fileUrl)}</span> }
                                        <button
                                            onClick={handleRemoveFile}
                                            className="remove-button"
                                        >
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M4.26683 12.6666L3.3335 11.7333L7.06683 7.99992L3.3335 4.26659L4.26683 3.33325L8.00016 7.06659L11.7335 3.33325L12.6668 4.26659L8.9335 7.99992L12.6668 11.7333L11.7335 12.6666L8.00016 8.93325L4.26683 12.6666Z"
                                                    fill="black"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={{marginTop:'10px', color: '#1A1A1A', fontWeight:'400', fontSize:'12px'}}>
                            {!readOnly && !file && <div> Attach pdf, jpg, zip file less than 1 MB </div>}
                            {!readOnly && file && <div>You have attached {file.name} file</div>}
                            {readOnly && fileUrl && fileUrl?.length > 2 && <div>You have attached {getFilename(fileUrl)} file</div>}
                        </div>
                    </div>
                </div>
               {!readOnly && <div className="feedback-form-buttons">
                    <button onClick={handleSubmit}>SKIP & SUBMIT FEEDBACK</button>
                    <button onClick={handleSubmit}>SUBMIT FEEDBACK</button>
                </div>}
            </>
        );
    };

    const ModalUI = () =>  (
            <div className="modal-overlay">
                <div className="modal-content">
                    <div className="modal-header">
                        <div>
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15.9998 0.166748C7.25984 0.166748 0.166504 7.26008 0.166504 16.0001C0.166504 24.7401 7.25984 31.8334 15.9998 31.8334C24.7398 31.8334 31.8332 24.7401 31.8332 16.0001C31.8332 7.26008 24.7398 0.166748 15.9998 0.166748ZM12.8332 23.9167L4.9165 16.0001L7.149 13.7676L12.8332 19.4359L24.8507 7.41841L27.0832 9.66675L12.8332 23.9167Z"
                                    fill="#3C763C"
                                />
                            </svg>
                        </div>
                        <h5 className="modal-title">Thank You</h5>
                    </div>
                    <div className="modal-body">
                        <div> Your Feedback ticket number is </div>
                        <div style={{ color: "#FF6100", fontWeight: "500" }}> {tktNo}.</div>
                        <div>
                            We shall get back to you soon. 
                            <br/> You should receive an eMail or SMS once our team replies back.
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button onClick={()=>{window.location.href="/";}} className="go-back-btn">
                            GO BACK HOME
                        </button>
                    </div>
                </div>
            </div>
        )

    const showOverallFeedback = () => (
        <div className="star-rating-heading">
            <h4>1. Overall Feedback (compulsory)</h4>
            <div className="star-rating-container">
                {labels.map((star, index) => {
                    const ratingValue = index + 1;
                    const isSelected = ratingValue <= feedbackRating;
                    return (
                        <div className="star-rating" key={`selStrRtgMp${index}`}>
                            <label key={index}>
                                <input
                                    type="radio"
                                    name="rating"
                                    value={ratingValue}
                                    onClick={() => !readOnly && handleStarClick(index + 1)}
                                />
                                <span
                                    className={isSelected ? "active-star" : "star"}
                                    role="img"
                                    aria-label={`${ratingValue} star`}
                                >
                                    {isSelected ? "★" : "☆"}
                                </span>
                            </label>
                            <span
                                style={{
                                    color:
                                        ratingValue === feedbackRating ? star.color : "#444",
                                }}
                            >
                                {star.name}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    )
        
    const showSubjectWiseRating = () => (
        <div className={`subject-rating-wrappper ${isSubjectDisabled ? "disabled" : ""}`}>
            <h4 className="tellus-more">2. Tell us more about following (compulsory)</h4>
            {selectSubject.map((el, index) => (
                <div key={"subject-"+el} className="subject-rating-card">
                    <div className="subject-heading">{el}</div>
                    <div className="subject-rating">
                        {SubjectRatingContent(el)}
                    </div>
                </div>
            ))}
        </div>
    )

     const SubjectRatingContent = (page = false) => {
        if (page && CategoriesData[page]) {
            return (
                <div className="ratings-wrap">
                    {CategoriesData[page].map((item) => (
                        <div className="ratings-star-icon" key={item.SubCategoryID}>
                            <div className="star-icon-heading">
                                <span>{item.SubCategory}</span>
                                <div>{renderStars(item.SubCategoryID)}</div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }
        return <></>;
    };

    const showDescExperience = () => (
        <div className={`desc-exp-wrappper ${isSubjectDisabled ? "disabled" : ""}`}>
            <h4 className="desc-exp-heading">3. Describe your experience (optional)</h4>
            <div className="desc-exp-textarea">
                <textarea
                    id="feedback"
                    value={feedback}
                    onChange={handleFeedbackChange}
                    placeholder="Overall the bus service could have been better in terms of cleanliness, and dropping & boarding points."
                    rows="4"
                    maxLength="500"
                    disabled={readOnly}
                    className="descExp"
                ></textarea>
            </div>
        </div>
    )

    const showFileUpload = () =>(
        <div className={`file-upload-wrappper ${isSubjectDisabled ? "disabled" : ""}`}>
            <h4 className="file-upload-heading">4. Attachment (optional)<span>Attach pdf, jpg, zip file less than 1MB</span></h4>
            <div className="file-upload-attachment">
                <div className="file-upload-attachment-label">
                    <label className="upload-label" htmlFor="file-input">
                        <span className="upload-button">
                            <svg
                                style={{ paddingTop: "3px" }}
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7 12V3.85L4.4 6.45L3 5L8 0L13 5L11.6 6.45L9 3.85V12H7ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V11H2V14H14V11H16V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2Z"
                                    fill="#FF7100"
                                />
                            </svg>
                            <span> Upload Supporting File</span>
                        </span>
                        <input
                            id="file-input"
                            type="file"
                            accept=".zip, .pdf, .jpg"
                            onChange={handleFileChange}
                            disabled={readOnly}
                            />
                    </label>
                    <div className="file-preview-container">
                        {( (!readOnly && file) || (readOnly && fileUrl && fileUrl?.length > 2) ) && (
                            <div className="file-preview">
                                {!readOnly && file && <span>{file.name}</span> }
                                {readOnly && fileUrl && fileUrl?.length > 2 && <span>{getFilename(fileUrl)}</span> }
                                <button
                                    onClick={handleRemoveFile}
                                    className="remove-button"
                                >
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M4.26683 12.6666L3.3335 11.7333L7.06683 7.99992L3.3335 4.26659L4.26683 3.33325L8.00016 7.06659L11.7335 3.33325L12.6668 4.26659L8.9335 7.99992L12.6668 11.7333L11.7335 12.6666L8.00016 8.93325L4.26683 12.6666Z"
                                            fill="black"
                                        />
                                    </svg>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <div style={{marginTop:'10px', color: '#1A1A1A', fontWeight:'400', fontSize:'12px'}}>
                    {/* !readOnly && !file && <div> Attach pdf, jpg, zip file less than 1 MB </div> */}
                    {!readOnly && file && <div>You have attached {file.name} file</div>}
                    {readOnly && fileUrl && fileUrl?.length > 2 && <div>You have attached {getFilename(fileUrl)} file</div>}
                </div>
            </div>
        </div>
    )

    const showLostItem = () => (
        <div className={`lost-item-wrappper ${isSubjectDisabled ? "disabled" : ""}`}>
            <h4 className="lost-item-heading">5. Lost Item  (optional) <Checkbox active={lostItem} onClick={()=>setLostItem(!lostItem)}/></h4>
            <div className="lost-item-textarea">
                {lostItem && LostItemUI()}
            </div>
        </div>
    )

    const showAction = () =>{
        return (
            <div
                className={
                    showFeedback  && feedbackRating > 0
                        ? "feedback-form-buttons"
                        : "feedback-form-buttons-disabled"
                }>
                <button onClick={handleSubmit}>SUBMIT</button>
            </div>
        )
    }

    return (
        <>
            <div className={`feedback-container ${readOnly?'readOnly':''}`}>
                {showOverallFeedback()}
                {showSubjectWiseRating()}
                {showDescExperience()}
                {showFileUpload()}
                {showLostItem()}
                {!readOnly && showAction()}            
                {showModal && ModalUI()}
            </div>
        </>
    );
};

export default FeedbackContentNew;
